import React from 'react';
import { Link } from 'react-router-dom';

function DoctorCard({ doctor }) {

  
  let imagePath = `/images/${doctor.image || 'doc_image/default_doc.webp'}`;
  if (doctor.image) {
      if (doctor.image.startsWith('data:image') || doctor.image.startsWith('http')) {
          imagePath = doctor.image;
      } else {
          imagePath = `/images/${doctor.image}`;
      }
  }

  return (
    <div className="container mt-4">
      <div className="doctor-card row align-items-center">

        {/* 1. Doctor Image */}
      <div className="col-md-2 text-center">
          <img 
            src={imagePath} 
            alt={doctor.name} 
            className="doctor-img mb-3 mb-md-0" 
            style={{ objectFit: 'cover' }} // Ensures uploaded images look good
          />
        </div>

        {/* 2. Doctor Info */}
        <div className="col-md-6">
          <h3 className="fw-bold mb-1"> {doctor.name}</h3>
          <p className="text-muted mb-1 fs-5">{doctor.specialty} Specialist</p>
          <p className="mb-2 fs-5">{doctor.qualifications}</p>
        
          <div className="d-flex gap-4 stats-row">
            <p className="mb-0 fs-5">
             
                <strong>{doctor.experience} Years</strong><br />
                <small className="text-muted">Experience</small>
            </p>
            <p className="mb-0 fs-5">
                <strong>100% ({doctor.reviews || 0})</strong><br />
                <small className="text-muted">Satisfied Patients</small>
            </p>
          </div>

     
          <div className="availability-box">
            <div className="availability-text">
              <i className="bi bi-circle-fill me-2" style={{ fontSize: '8px', verticalAlign: 'middle' }}></i>
              Available Today
            </div>
            <div className="fee-text">
              Rs. {doctor.fee || '2000'}
            </div>
          </div>
        </div>

     
        <div className="col-md-3 d-flex flex-column align-items-start justify-content-center ps-4 action-col">
          
          {/* Book Button */}
          <div className="w-100 text-center-mobile"> 
            <Link to={`/book/${doctor._id}`} className="book-btn-solid">
              Book Appointment
            </Link>
          </div>

          <div className="social-list-vertical">
            <a href="#twitter"><i className="bi bi-twitter"></i> Twitter</a>
            <a href="#facebook"><i className="bi bi-facebook"></i> Facebook</a>
            <a href="#instagram"><i className="bi bi-instagram"></i> Instagram</a>
            <a href="#linkedin"><i className="bi bi-linkedin"></i> LinkedIn</a>
          </div>

        </div>

      </div>
    </div>
  );
}

export default DoctorCard;